let currentFbPixel = null;

export function initFacebookPixel(pixel) {
  if (!pixel) return;

  // 已初始化同一个 Pixel
  if (currentFbPixel === pixel && window.fbq) {
    return;
  }

  // 已存在 fbq，不重复创建 SDK
  if (!window.fbq) {
    window.fbq = function () {
      window.fbq.callMethod
        ? window.fbq.callMethod.apply(window.fbq, arguments)
        : window.fbq.queue.push(arguments);
    };

    window.fbq.queue = [];
    window.fbq.loaded = true;
    window.fbq.version = "2.0";

    const script = document.createElement("script");

    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";

    document.head.appendChild(script);
  }

  window.fbq("set", "autoConfig", false, pixel);

  window.fbq("init", pixel);

  window.fbq("track", "PageView");

  currentFbPixel = pixel;
}
